import {
  CSSVarNames,
  HEADER_CLASSES,
  HEADER_TRANSITION_BREAKPOINT,
  SCREEN_TYPE
} from "../../constants";
import {
  HeaderActionCreators,
  UIActionCreators
} from "../../redux/action-creators";
import { HeaderSelectors, UISelectors } from "../../redux/selectors";
import { useDispatch, useSelector } from "react-redux";
import DocumentHelper from "../../utils/documentHelper";
import { UIUtils } from "../../utils";
import { useCallback } from "react";
import { useResizeDetector } from "react-resize-detector";

const getScreenType = () => {
  let headerWrapperState;
  const windowWidth = UIUtils.getWidth();
  if (windowWidth <= HEADER_TRANSITION_BREAKPOINT.WIDTH_SMALL_SCREEN) {
    headerWrapperState = SCREEN_TYPE.MOBILE;
  } else if (windowWidth <= HEADER_TRANSITION_BREAKPOINT.WIDTH_WIDE_SCREEN) {
    headerWrapperState = SCREEN_TYPE.REGULAR;
  } else headerWrapperState = SCREEN_TYPE.WIDE;

  return headerWrapperState;
};

const getClassName = () => {
  const windowWidth = UIUtils.getWidth();

  let className = HEADER_CLASSES.WIDTH_REGULAR_SCREEN;

  if (windowWidth <= HEADER_TRANSITION_BREAKPOINT.WIDTH_SMALL_SCREEN) {
    className = HEADER_CLASSES.WIDTH_SMALL_SCREEN;
  } else if (windowWidth <= HEADER_TRANSITION_BREAKPOINT.WIDTH_WIDE_SCREEN) {
    className = HEADER_CLASSES.WIDTH_WIDE_SCREEN;
  }

  return className;
};

DocumentHelper.onDomReady(() => {
  const className = getClassName();
  if (className) {
    document.body.classList.add(className);
  }
});

export const useHeaderHeightResizeDetector = () => {
  const dispatch = useDispatch();

  const setBodyPadding = useCallback(() => {
    const header = document.querySelector(".headerWrapper");
    const headerHeight = header?.getBoundingClientRect().height || 0;
    dispatch(HeaderActionCreators.setHeaderHeight(headerHeight));
    const clientElement = document.querySelector(
      "#uc-spectate-sport-client-view"
    );
    if (!clientElement) return;
    const clientGap =
      getComputedStyle(clientElement).getPropertyValue("padding-top");

    const className = getClassName();
    const varName =
      className === HEADER_CLASSES.WIDTH_SMALL_SCREEN
        ? CSSVarNames.HeaderMobile
        : CSSVarNames.HeaderPC;
    const removedVarName =
      className === HEADER_CLASSES.WIDTH_SMALL_SCREEN
        ? CSSVarNames.HeaderPC
        : CSSVarNames.HeaderMobile;

    document.body.style.setProperty(varName, `${headerHeight}px`);
    document.body.style.setProperty(CSSVarNames.ClientTopGap, clientGap);
    document.body.style.removeProperty(removedVarName);
  }, [dispatch]);

  const { ref } = useResizeDetector({
    skipOnMount: false,
    refreshMode: "throttle",
    refreshRate: 100,
    handleWidth: false,
    handleHeight: true,
    onResize: setBodyPadding
  });
  return ref;
};

export const useHeaderWidthResizeDetector = () => {
  const dispatch = useDispatch();
  const screenType = useSelector(UISelectors.screenType);
  const bodyClassName = useSelector(HeaderSelectors.bodyClassName);

  const updateBodyWrapperClass = useCallback(() => {
    const className = getClassName();

    Object.values(HEADER_CLASSES)
      .filter(headerClass => headerClass !== className)
      .forEach(
        headerClass =>
          headerClass && document.body.classList.remove(headerClass)
      );
    if (className !== bodyClassName)
      dispatch(HeaderActionCreators.setBodyClassName(className));
    if (className) document.body.classList.add(className);
  }, [bodyClassName, dispatch]);

  const setLayout = useCallback(() => {
    const newScreenType = getScreenType();

    if (screenType !== newScreenType) {
      dispatch(UIActionCreators.setScreenType(newScreenType));
    }
  }, [dispatch, screenType]);

  const onResize = useCallback(() => {
    setTimeout(() => {
      setLayout();
      updateBodyWrapperClass();
    }, 0);
  }, [setLayout, updateBodyWrapperClass]);

  const { ref } = useResizeDetector({
    skipOnMount: false,
    refreshMode: "throttle",
    refreshRate: 100,
    handleWidth: true,
    handleHeight: false,
    onResize
  });
  return ref;
};
